module.exports = __webpack_public_path__ + "static/joao_ramos-b032792f413035187775607b61c66b53.png";